{
  "styles": {
    "models": {
      "resetHeight": "Restablecer altura",
      "resetLength": "Restablecer la longitud",
      "resetWidth": "Restablecer ancho",
      "attributeModel": "Edite su modelo 3D cambiando el modelo y las dimensiones",
      "attributeDimensions": "Edite su modelo 3D cambiando las dimensiones",
      "determineModel": "Determine el modelo por",
      "determineDimensions": "Determine la longitud, el ancho y la altura mediante"
    }
  },
  "exports": {
    "legendPosition": "Posición de la leyenda",
    "top": "Arriba",
    "bottom": "Parte inferior",
    "left": "Izquierda",
    "right": "Derecha",
    "layers": "Capas",
    "all": "Todas",
    "custom": "Personalizado",
    "selectLayers": "Seleccione las capas para exportar",
    "selected": "seleccionado",
    "hidden": "(Oculto)",
    "none": "Ninguno"
  },
  "get_map_errors": {
    "default": "Algo salió mal",
    "not_found": "No se encontró el plan",
    "click_here_to_browser_maps": "Haga clic aquí para ver los planes"
  },
  "add_list_item_attribute": {
    "title": "Agregar columna",
    "subtitle": "Edite este atributo según sus necesidades utilizando los campos siguientes",
    "column_name": "Nombre de la columna",
    "column_type": "Tipo de columna",
    "type": "Tipo de propiedad"
  },
  "list_item_properties": {
    "additional_properties": "Propiedades adicionales"
  },
  "contextMenu": {
    "import": "Importar",
    "export": "Exportación",
    "copy_layer": "Copiar capa {{ pluralise }}",
    "copy_group": "Copiar grupo {{ pluralise }}",
    "copy_layer_and_group": "Copia la capa {{ pluraliseLayers }} y el grupo {{ pluraliseGroups }}",
    "delete": "Eliminar",
    "delete_layers_title": "Eliminar capas",
    "delete_layers_description": "Una o más de las capas que está intentando eliminar están vinculadas a otro mapa. Se van a eliminar de este mapa y puede volver a vincularlas en cualquier momento."
  },
  "copyOrUnlinkLayers": {
    "copy": "Copiar",
    "unlink": "Desvincular",
    "copying_layers": "Copiar capas",
    "unlink_layer": "Desvincular una capa",
    "linked_layers": "Capas enlazadas",
    "original_plan": "Plan original",
    "helpbase_blurb": {
      "click": "Haga clic aquí",
      "link": "Cómo empezar - Base de conocimientos (iventis.com)",
      "further_info": "para obtener más información."
    },
    "copy_blurb": {
      "are_you_sure": "¿Está seguro de que desea copiar",
      "this": "esto",
      "these": "estos",
      "layer": "capa {{ pluralise }}",
      "group": "grupo {{ pluralise }}",
      "layers_and_groups": "capas y grupos"
    },
    "unlink_info": {
      "links_to": "Esta capa enlaza con",
      "changes_not_reflected": "Al desvincularse de su plan original, está creando una copia. Los cambios realizados en la capa original dejarán de reflejarse en su plan."
    },
    "unlink_blurb": "Está copiando capas vinculadas a diferentes mapas. Al desvincularla de su plan original, está creando una copia. Los cambios realizados en la capa original dejarán de reflejarse en su plan.",
    "copy_with_map_objects": "Copie la capa {{ pluralise }} con objetos del mapa"
  },
  "shareMap": {
    "title": "Comparte el plan",
    "share_with_team": "Comparte con el equipo",
    "share_with_team_details": "Comparte el plan con los miembros del equipo trasladándolo al «Espacio de trabajo en equipo»",
    "shared_library": {
      "title": "Comparte el archivo con el equipo",
      "footer": "Los miembros del equipo pueden ver el archivo como de solo lectura"
    },
    "shared_link": {
      "title": "Compartir enlace"
    },
    "share_link": "Generar enlace",
    "share_link_details": "Cree un enlace temporal de solo lectura para compartir este plan con los usuarios que no tienen acceso a Iventis",
    "share_link_generated": "Este enlace caducará en {{ numberOfDays }} días. Puedes generar un enlace nuevo en cualquier momento."
  },
  "defaultAttribute": {
    "add": "Agregue un valor predeterminado para el atributo",
    "default_field_type": "Valor predeterminado de {{ dataFieldType }}",
    "tickbox": {
      "label": "Estado predeterminado de la casilla de verificación",
      "on": "EN",
      "off": "APAGADO"
    }
  },
  "fileUpload": {
    "import_title": "Importar datos al mapa",
    "drop_file": "Suelta el archivo para subirlo",
    "supported_extensions": "Extensiones compatibles",
    "contact_support": "Póngase en contacto con el servicio de asistencia técnica para archivos más grandes y otras extensiones",
    "choose_file": "Elige un archivo",
    "max_file_size": "Tamaño máximo de archivo {{ maxFileSize }} MB"
  }
}